module.exports = __webpack_public_path__ + "static/media/phone.8b7122d9.svg";